import React from 'react'
import AntdCheckbox from 'antd/lib/checkbox'
import './index.less'

const Checkbox = props => (
  <AntdCheckbox {...props} />
)

export default Checkbox



// WEBPACK FOOTER //
// ./src/elements/checkbox/index.js